import { Sepa, Swift } from "@/Images"
import { IBANContext, PaymentSystem } from "@usher/pe-client-front-end-lib"
import { HTMLAttributes, useContext } from "react"

interface Props extends HTMLAttributes<HTMLSpanElement> {
  currency?: string
}
export const PaymentSystemLogo = ({ currency, ...props }: Props) => {
  const { paymentSystem } = useContext(IBANContext)
  let ICON = paymentSystem === PaymentSystem.SEPA ? Sepa : Swift
  if (currency != null) currency === "EUR" ? (ICON = Sepa) : (ICON = Swift)
  return (
    <span {...props}>
      <ICON width={50} height={20} className="mr-2" />
    </span>
  )
}
